import React from 'react'
import styled from 'styled-components'
import Link from 'gatsby-link'
import Img from 'gatsby-image'
import presets from "../utils/presets"
import {rhythm} from "../utils/typography"

// const tile = presets.blogTileSize;
// const tile = rhythm(5);
const mobileTile = "12em" ;
const phabletTile = "10em" ;
const tabletPorTile = "12em" ;
const tabletLanTile = "12em" ;
// we didn't need the rest of these presets:
// const desktopTile = "120px" ;
// const hdTile = "120px" ;
// const vhdTile = "120px" ;
// const vvhdTile = "120px" ;
// const fourk = "120px" ;

const SeeGrid = styled.div`
  display: grid;
  grid-auto-flow: row;
  grid-template-columns: repeat(auto-fill, minmax(${mobileTile}, 1fr));
  grid-auto-rows: ${mobileTile};
  grid-gap: ${rhythm(1)};

  width:calc(100% - ${rhythm(2)});
  max-width:${rhythm(28)};
  margin:0 auto;
  margin-bottom: ${rhythm(1.5)};
  ${'' /* repeat(number of columns/rows, the column width we want); */}
  a{
    ${presets.shadowLow}
    font-size: 0.8rem;
    div{
      height:100%;
      width:100%;
    }
    background-color: unset;
  }
  p{
    position:absolute;
    bottom:0;
    font-weight:400;
    padding-right: ${rhythm(0.5)};
    margin-bottom: ${rhythm(0.5)};
  }


  @media screen and ${presets.phablet.por}{
    grid-template-columns: repeat(auto-fill, minmax(${phabletTile}, 1fr));
    grid-auto-rows: ${phabletTile};
  }

  @media screen and ${presets.tablet.por}{
    grid-template-columns: repeat(auto-fill, minmax(${tabletPorTile}, 1fr));
    grid-auto-rows: ${tabletPorTile};
  }

  @media screen and ${presets.tablet.lan}{
    grid-template-columns: repeat(auto-fill, minmax(${tabletLanTile}, 1fr));
    grid-auto-rows: ${tabletLanTile};
  }

  ${'' /* @media screen and ${presets.desktop.lan}{

  }

  @media screen and ${presets.hd.lan}{

  }

  @media screen and ${presets.vhd.lan}{

  }

  @media screen and ${presets.vvhd.lan}{

  } */}
`
export default SeeGrid



// WEBPACK FOOTER //
// ./src/com/SeeGrid.js